/**
 * @module FE-CU32_アカウント管理対象地区画面
 */
import Header from '../../../components/header/Header.vue';
import PcPageTitle from '../../../components/pcPageTitle/PcPageTitle.vue';
import ListPanel from '../../../components/listPanel/ListPanel.vue';
import MobileFooter from '../../../components/footer/MobileFooter.vue';
import BreadCrumbList from '@/components/breadCrumb/List.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import CONSTANTS from '../../../constants';

const PAGE_ID = 'FE-CU32';
export default {
  name: 'DisplayDistrictAccountManagement',
  components: {
    Header,
    PcPageTitle,
    BreadCrumbList,
    ListPanel,
    MobileFooter,
    PCFooter,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t(
        '$vuetify.FECU32アカウント管理対象地区画面.アカウント管理_対象地区'
      ),
      hintText: vm.$vuetify.lang.t(
        '$vuetify.メッセージ一覧.FECU32アカウント管理対象地区画面.C0001'
      ),
      panelTitle: '',
      result: [],
      panelTitles: [],
      items: [],
      authorities: [],
      width: 0,
      takeoverFlg: false,
      userAuthorityFlg: false,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t(
          '$vuetify.FECU32アカウント管理対象地区画面.アカウント管理_対象地区'
        ),
        hintText: vm.$vuetify.lang.t(
          '$vuetify.メッセージ一覧.FECU32アカウント管理対象地区画面.C0001'
        ),
      };
    },
    /**
     * ヘッダーに戻るボタンを表示するか
     * @returns {boolean} ヘッダーに戻るボタンを表示するか
     * @description アプリから遷移した場合は戻るボタンを表示しない
     */
    displayBackButton() {
      return this.$mq === 'pc' ? true : !(this.$route.query.takeoverToken && this.$isBrowser);
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * ストアの画面タイプに対象地区を設定
     * @param {*} customerNumber お客様番号
     * @param {*} districtSplitNumber 地区番号
     * @param {*} displayDistrictUserType 対象地区ユーザ種別
     */
    setStateDisplayArea(customerNumber, districtSplitNumber, displayDistrictUserType) {
      this.$store.state.currentDisplayType = 1;
      this.$store.state.customerNumber = customerNumber;
      this.$store.state.districtSplitNumber = districtSplitNumber;
      this.$store.state.displayDistrictUserType = displayDistrictUserType;
    },
    /**
     * 初期表示API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストパラメータ
     * @param {*} method メソッドパラメータ
     * @returns apiData レスポンス
     */
    getDisplayDistrictAccountManagementList: async function (param, queries, method) {
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            if (method === 'get' || method === 'post' || method === 'put') {
              apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

              // サンプルデータ
              // apiData = {
              //   contentsInfo: {
              //     displayDistrictListInfo: [
              //       {
              //         displayDistrictNickname: "自宅",
              //         displayDistrictUserType: 1, // 1：メインユーザー、２：サブユーザー
              //         userManagementAuthority: true, // ユーザー管理権限あり、なし
              //         emergencyContactAuthority: true, // 緊急連絡先権限あり、なし
              //         customerNumber: "51-1234567", // お客様番号
              //         securityDestinationName: "警備 太郎 宅", // 警備先名称
              //         districtSplitNumber: "    ", // 地区番号
              //         districtSplitName: "リビング", // 地区名
              //       },
              //       {
              //         displayDistrictNickname: "鹿児島の別荘",
              //         displayDistrictUserType: 1,
              //         userManagementAuthority: true,
              //         emergencyContactAuthority: true,
              //         customerNumber: "51-1234567",
              //         securityDestinationName: "別荘 太郎 宅",
              //         districtSplitNumber: "0001",
              //         districtSplitName: "ダイニング",
              //       },
              //     ],
              //   },
              // };

              // ヘッダー・フッターホームセキュリティ表示フラグ（Navのホームセキュリティボタンも表示制御する。）
              if (!this.userAuthorityFlg || apiData.contentsInfo.displayDistrictInfo.length == 0) {
                this.$store.state.disableHomeSecurityActive = true;
              } else {
                this.$store.state.disableHomeSecurityActive = false;
              }

              //------------ 以下整形処理 ------------------------
              apiData?.contentsInfo?.displayDistrictInfo.map((item) => {
                let authority = {};

                this.authorities.map((authInfo) => {
                  if (
                    authInfo.customerNumber === item.customerNumber && // #29157
                    authInfo.districtSplitNumber === item.districtSplitNumber
                  ) {
                    authority = authInfo.authority;
                  }
                });

                let displayItems = [];
                // ユーザー管理権限をもつユーザーの場合ユーザー管理をセット
                if (item?.userManagementAuthority && authority.management) {
                  displayItems = [
                    ...displayItems,
                    {
                      id: 1,
                      title: '$vuetify.FECU32アカウント管理対象地区画面.ユーザー管理',
                      text: '$vuetify.FECU32アカウント管理対象地区画面.ユーザー管理変更ボタン',
                      url: '/userManagement',
                      isVuetifyKey: true,
                      linkClickAction: () =>
                        this.setStateDisplayArea(
                          item.customerNumber,
                          item.districtSplitNumber,
                          item.displayDistrictUserType
                        ),
                    },
                  ];
                }

                // 緊急連絡先権限をもつ場合緊急連絡先権限をセット
                if (
                  item.emergencyContactAuthority &&
                  authority.contact &&
                  (item.usagePlanId == CONSTANTS.HOME_SECURITY_USAGE_PLAN.ONLINE_MONITORING_PLAN ||
                    item.usagePlanId ==
                      CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN)
                ) {
                  displayItems = [
                    ...displayItems,
                    {
                      id: 2,
                      title: '$vuetify.FECU32アカウント管理対象地区画面.緊急連絡先',
                      text: '$vuetify.FECU32アカウント管理対象地区画面.緊急連絡策変更ボタン',
                      url: '/emergencyContact',
                      isVuetifyKey: true,
                      linkClickAction: () => {
                        this.$store.state.emergencyContactNumber = 0;
                        this.setStateDisplayArea(
                          item.customerNumber,
                          item.districtSplitNumber,
                          item.displayDistrictUserType
                        );
                      },
                    },
                  ];
                }

                // 各種情報をセット
                displayItems = [
                  ...displayItems,
                  {
                    id: 3,
                    title: '$vuetify.FECU32アカウント管理対象地区画面.お客様番号',
                    text: item?.customerNumber,
                    url: null,
                  },
                  {
                    id: 4,
                    title: '$vuetify.FECU32アカウント管理対象地区画面.警備先名',
                    text: item?.securityDestinationName,
                    url: null,
                  },
                  {
                    id: 5,
                    title: '$vuetify.FECU32アカウント管理対象地区画面.地区番号',
                    text: item?.districtSplitNumber,
                    url: null,
                  },
                  {
                    id: 6,
                    title: '$vuetify.FECU32アカウント管理対象地区画面.地区名',
                    text: item?.districtSplitName,
                    url: null,
                  },
                ];

                displayItems.map((item) => {
                  if (item.id === 5) {
                    if (item.text === '    ') {
                      item.text = '$vuetify.FECU32アカウント管理対象地区画面.メイン地区';
                    }
                  }
                });

                displayItems = displayItems.filter((item) => {
                  if (item.id === 5 && item.text === '') {
                    return;
                  } else {
                    return item;
                  }
                });

                const userTypeName =
                  item.displayDistrictUserType === 1 ? 'メインユーザー' : 'サブユーザー';
                const panelTitle = {
                  place: `${item.displayDistrictNickname} -  `,
                  type: `${
                    userTypeName === 'メインユーザー'
                      ? '$vuetify.FECU33アカウント管理カメラ画面.ユーザー権限データ.メインユーザー'
                      : '$vuetify.FECU33アカウント管理カメラ画面.ユーザー権限データ.サブユーザー'
                  }`,
                  typeIsBefore: false,
                };
                this.panelTitles = [...this.panelTitles, panelTitle];

                this.result = [
                  ...this.result,
                  { panelTitles: this.panelTitles, items: displayItems },
                ];
              });
            }
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * ユーザー権限一覧取得API実行処理
     */
    async APP_CU9916() {
      let param = '/api/common/getRoleList';
      // let param = "post";

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
      };

      let method = 'post';
      let apiData = '';
      this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     displayDistrictInfoList: {
            //       customerNumber: "sendCustomerNumber",
            //       districtSplitNumber: "sendCustomerNumber",
            //       displayDistrictUserType: 1,
            //       userAuthority: {
            //         securityOperation: true,
            //         rushOrder: true,
            //         notificationHistory: true,
            //         deviceContorol: true,
            //         contact: true,
            //         nicknameSetting: true,
            //         IDCardKeyInfoSetting: true,
            //         watchOverInfoDeliverySetting: true,
            //         lockUpCheck: true,
            //         targetAtHomeSetting: true,
            //         userManagement: true,
            //         emergencyContact: true,
            //       },
            //     },
            //     cameraInfoList: {
            //       customerNumber: "customerNumber",
            //       districtSplitNumber: "districtSplitNumber",
            //       deviceID: "deviceID",
            //       cameraUserType: 0,
            //       userAuthority: {
            //         anticrimeCameraVideos: false,
            //         rushOrder: false,
            //         notificationHistory: false,
            //         contact: false,
            //         nicknameSetting: false,
            //         userManagement: false,
            //         emergencyContact: false,
            //       },
            //     },
            //   },
            // };

            apiData.contentsInfo.displayDistrictInfoList.map((info) => {
              let authority = { management: false, contact: false };
              if (
                info.userAuthority.securityOperation == false &&
                info.userAuthority.rushOrder == false &&
                info.userAuthority.notificationHistory == false &&
                info.userAuthority.deviceContorol == false &&
                info.userAuthority.contact == false &&
                info.userAuthority.nicknameSetting == false &&
                info.userAuthority.IDCardKeyInfoSetting == false &&
                info.userAuthority.watchOverInfoDeliverySetting == false &&
                info.userAuthority.lockUpCheck == false &&
                info.userAuthority.targetAtHomeSetting == false &&
                info.userAuthority.userManagement == false &&
                info.userAuthority.emergencyContact == false
              ) {
                // 全てfalseである場合、画面項目No.7,8を非表示にする。
                authority.management = false;
                authority.contact = false;
              } else {
                authority.management = true;
                authority.contact = true;
                if (!this.userAuthorityFlg) this.userAuthorityFlg = true;
              }

              if (info.userAuthority.userManagement) {
                authority.management = true;
              }

              if (info.userAuthority.emergencyContact) {
                authority.contact = true;
              }

              this.authorities.push({
                customerNumber: info.customerNumber, // #29157
                districtSplitNumber: info.districtSplitNumber,
                authority: authority,
              });
            });

            if (apiData.contentsInfo.displayDistrictInfoList.length != 0) {
              this.$store.state.isTopHomeSecurityActive = true;
            }

            if (apiData.contentsInfo.cameraInfoList.length != 0) {
              this.$store.state.isTopCameraActive = true;
            }
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        )
        .then(async () => {
          let param = '/api/displayDistrictAccountManagement/init';
          // let param = "post";

          let queries = {
            token: sessionStorage.getItem('token'),
            terminalInfo: localStorage.getItem('terminalInfo')
              ? localStorage.getItem('terminalInfo')
              : '',
          };

          let method = 'post';
          // APP_CU0801
          await this.getDisplayDistrictAccountManagementList(param, queries, method);
        });
    },
    /**
     * 継続ログイン認証API実行処理
     */
    async APP_CU9913() {
      let param = '/api/common/continueLogin';
      let queries = {
        takeOverToken: this.$route.query.takeoverToken,
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
      };

      let method = 'post';
      let apiData = '';

      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          async (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // apiData = {
            //   contentsInfo:{
            //     loginResult: 0   // 0: ログイン成功 | 1: 2段階認証が必要 | 2: ログイン失敗
            //   },
            //   token: "string"
            // }
            this.$store.commit('setTakeoverTokenFlg', { takeoverTokenFlg: true });
            switch (apiData.contentsInfo.loginResult) {
              case 0: {
                this.$store.commit('setIsLoggedIn', { isLoggedIn: true });
                sessionStorage.setItem('token', apiData.token);
                // 権限取得APP_CU9916
                await this.APP_CU9916();
                if (this.$store.getters['isLoggedIn']) {
                  await this.$refs.header.APP_CU0201();
                }
                break;
              }
              case 1: {
                let handoverToken = apiData.token;
                this.$router.push({
                  path: '/twoStepAuthentication',
                  query: {
                    handoverToken: handoverToken,
                    targetPage: '/displayDistrictAccountManagement',
                  },
                });
                break;
              }
              case 2: {
                this.$_abnormality(500);
                break;
              }
              default: {
                this.$_abnormality(500);
                break;
              }
            }
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
    },
    changeItemLabelWidth(width) {
      this.width = width;
    },
  },
  beforMount() {
    this.$_setLoading(true);
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // アプリから遷移時orリロード時
      if (from.path == '/') {
        vm.takeoverFlg = true;
        next();
      } else {
        next();
      }
    });
  },
  async mounted() {
    if (this.$route.query.takeoverToken && this.$isBrowser && this.takeoverFlg) {
      this.$store.commit('setTakeoverTokenFlg', { takeoverTokenFlg: false });
    }

    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    //ローディングマーク表示と合わせて色々再見直ししたほうが良いかも
    this.isShowPage = true;

    // 継続ログイン認証APP_CU9913
    if (this.$route.query.takeoverToken && this.$isBrowser && !this.$store.state.takeoverTokenFlg) {
      await this.APP_CU9913();
    } else {
      // 権限取得APP_CU9916
      this.$store.commit('setTakeoverTokenFlg', { takeoverTokenFlg: true });
      await this.APP_CU9916();
      if (this.$store.getters['isLoggedIn']) {
        await this.$refs.header.APP_CU0201();
      }
    }
  },
};
